import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { supabase } from "../lib/supabase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => setSession(s ?? null));
    return () => sub.subscription.unsubscribe();
  }, []);

  const signIn = async (email, password) => {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw new Error(error.message);
  };

  const signUp = async (email, password, username) => {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/signup`, {
      email,
      password,
      username,
    });
    await signIn(email, password);
  };

  const signOut = () => supabase.auth.signOut();

  const user = session?.user
    ? {
        id: session.user.id,
        email: session.user.email,
        username: session.user.user_metadata?.username || session.user.email?.split("@")[0],
      }
    : null;

  return (
    <AuthContext.Provider value={{ session, user, loading: session === undefined, signIn, signUp, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
